import * as React from "react";
const WeeklyMeets = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    {...props}
  >
    <rect width={32} height={32} fill="#fff" fillOpacity={0.08} rx={16} />
    <mask
      id="aWeeklyMeets"
      width={20}
      height={20}
      x={6}
      y={6}
      maskUnits="userSpaceOnUse"
      style={{
        maskType: "alpha",
      }}
    >
      <path fill="#D9D9D9" d="M6 6h20v20H6z" />
    </mask>
    <g mask="url(#aWeeklyMeets)">
      <path
        fill="#F1F5F9"
        d="M10.167 12.667h11.666V11H10.167v1.667Zm0 11.666c-.459 0-.851-.163-1.177-.49a1.605 1.605 0 0 1-.49-1.176V11c0-.458.163-.85.49-1.177.326-.327.718-.49 1.177-.49H11V7.667h1.667v1.666h6.666V7.667H21v1.666h.833c.459 0 .851.163 1.177.49.327.326.49.719.49 1.177v4.73a5.773 5.773 0 0 0-1.667-.5v-.897H10.167v8.334h5.25c.097.305.212.597.343.875.132.277.289.541.47.791h-6.063ZM21 25.167c-1.153 0-2.135-.407-2.948-1.22-.812-.812-1.219-1.794-1.219-2.947s.407-2.136 1.22-2.948c.812-.813 1.794-1.219 2.947-1.219s2.135.407 2.948 1.219c.812.813 1.219 1.795 1.219 2.948s-.407 2.135-1.22 2.948c-.812.812-1.794 1.219-2.947 1.219Zm1.396-2.188.583-.583-1.562-1.563V18.5h-.834v2.667l1.813 1.812Z"
      />
    </g>
  </svg>
);
export default WeeklyMeets;
